module.exports = __webpack_public_path__ + "img/cap.cbad7e9e.png";